import { ref } from 'vue';

export const drawer = ref(false);
